import { Component, OnInit, OnDestroy, Input, AfterViewInit, ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertService, MessageSeverity, DialogType } from '../../services/alert.service';
import { UserLogin } from '../../models/user-login.model';
import { ICD, MasterConfig, ResponseAPI, ErrorList, ICDStep2 } from '../../models/IDPReport.model';
import { SfDataService } from '../../services/sf-data.service';
import { AuthService } from '../../services/auth.service';
import { ConfigurationService } from '../../services/configuration.service';
import { Utilities } from '../../services/utilities';
import { elevenDigitPhoneNumberValidator, PhoneNumberMaskDirective, tenDigitPhoneNumberValidator } from '../../phone-number-mask.directive';

import Swal from 'sweetalert2';

// Use globally loaded jQuery (index.html) — module-bundled jQuery is a separate instance without jQuery UI/select2
declare const $: any;

// import custom validator to validate 
import { MustMatch } from '../../models/MustMatch';
import { dateNotLessThanTodayValidator } from '../../models/dateNotLessThanTodayValidator';
import { postalCodeValidator } from '../../models/postalCodeValidator';
import { AgentService, PreSubmitIssue } from '../../services/agent.service';
import { AiHintStateService } from '../../services/ai-hint-state.service';


@Component({
    selector: 'app-sf-icd-info',
    templateUrl: './sf-icd-info.component.html',
    styleUrls: ['./sf-icd-info.component.scss'],
    standalone: false
})


export class SfIcdInfoComponent implements OnInit, AfterViewInit, OnDestroy {
  icd = new ICDStep2();
  isFileProcessing: boolean = false;
  private destroy$ = new Subject<void>();

  data = {
    name: 'John',
    age: 30
  };
  noMiddleName: boolean = true;  // "No Middle Name" checked by default (matches Step 1)
  secondaryOwner: string = '';   // Feature 10 — concatenated secondary owner name (read-only display)
  userLogin = new UserLogin(); id: string; q: string;
  isLoading = false;
  formResetToggle = true;
  modalClosedCallback: () => void;
  loginStatusSubscription: any;
  selectedCountry: string;
  ssnValue: string = '';
  isUS: boolean = true;
  displayValue: string = '';
  displayValue_C: string = '';
  icdForm: FormGroup;
  @Input()
  isModal = false;
  IsPref_Differ = false;
  submitted = false;
  ddlUSStates = [];
  ddlCAProvinence = [];
  demographicsData: string[] = [
    'Asian-Indian', 'Asian-Pacific', 'Black or African-American', 'Hispanic', 'Native American',
    'Woman/Women', 'LGBTQ+', 'Veteran', 'None Apply', 'Decline to respond'
  ];
  maxFileSize = 10 * 1024 * 1024; // 10 MB max file size (FR3)
  allowedFormats = ['pdf', 'jpg', 'jpeg', 'png'];
  maxFiles = 1;

  selectedDemographics: string[] = [];
  selectedFiles: FileList;
  validFiles: File[] = [];
  fileData: { attachment_FileName: string, attachment_Base64: string, attachment_Type: string, FileId?: string, Url?: string, status?: 'uploading' | 'uploaded' | 'error' }[] = [];
  maxFilesAllowed: number = 5; // Maximum number of files allowed
  // Staged upload-on-select state, keyed by form control name.
  uploadState: { [controlName: string]: 'uploading' | 'uploaded' | 'error' } = {};
  uploadError: { [controlName: string]: string } = {};
  // Per-control selection counter so a slow FileReader from a superseded selection is ignored (FR2).
  private uploadSeq: { [controlName: string]: number } = {};



  isDemographicsInvalid: boolean = false;
  isConsentInvalid: boolean = false;
  icd_o = new ICD();
  @Output() dataEmitter = new EventEmitter<any>();
  @Input() inputData: any;

  public masterConfig: MasterConfig[] = [];

  datad = {
    name: '',
    age: 0
  };

  @Output() idEmitter = new EventEmitter<string>();
  //@ViewChild('dobInput') dobInput: ElementRef;
  //@ViewChild('datepicker') datepicker: ElementRef;
  @ViewChild('selectEl') selectEl: ElementRef;

  select2Options = {
    placeholder: 'Select an option...',
    width: '100%'
  };

  selectedOption: string;
  isOTPValid = false;
  btnDisplay = true;

  // Pre-submit review
  showPreSubmitReview = false;
  preSubmitIssues: PreSubmitIssue[] = [];
  preSubmitLoading = false;
  verificationState: { [controlName: string]: 'pending' | 'verifying' | 'pass' | 'fail' | 'warn' } = {};
  verificationIssues: { [controlName: string]: string[] } = {};

  private readonly VERIFIED_DOC_TYPES: { [controlName: string]: string } = {
    Attach_Govt_Issued_ID: 'GovernmentID',
  };

  controlDisplayNames: { [key: string]: string } = {

    US_or_CA: 'Country',
    Full_Legal_Company_Name: 'Full Legal Company Name',
    Tax_ID: 'Tax ID',

    State_of_Incorporation: 'State Of Incorporation',
    Provinence_of_Incorporation: 'Province Of Incorporation',

    Company_Address1: 'Company Address 1',
    Company_City: 'Company City',
    Company_Postal_Code: 'Company Postal Code',
    Company_Office_Phone: 'Company Office Phone',
    Company_Business_Email: 'Company Business Email',

    Company_Country: 'Company County',
    Company_State: 'Company State',
    Company_Province: 'Company Province',

    SSN_SIN: 'SSN/SIN',
    SSN_SIN_C: 'Confirm SSN/SIN',

    Owner_First_Name: 'Owner First Name',
    Owner_Last_Name: 'Owner Last Name',
    Owner_Middle_Name: 'Owner Middle Name',

    Owner_Preferred_First_Name: 'Preferred First Name',
    Owner_Preferred_Last_Name: 'Preferred Last Name',

    Is_Preferred_Differ: 'Preferred Name Different',

    Attach_Govt_Issued_ID: 'Government Issued ID',

    Owner_Perc: 'Ownership Percentage',

    Owner_Address1: 'Owner Address 1',
    Owner_City: 'Owner City',
    Owner_State: 'Owner State',
    Owner_Province: 'Owner Province',
    Owner_Postal_Code: 'Owner Postal Code',

    Owner_Mobile_Phone: 'Owner Mobile Phone',
    Owner_Home_Phone: 'Owner Home Phone',
    Owner_Email: 'Owner Email'
  };

  fieldMaxLengths: any = {
    Full_Legal_Company_Name: 255,
    Tax_ID: 25,
    Company_Address1: 150,
    Company_Address2: 150,
    Company_City: 150,
    Company_Postal_Code: 10,
    Company_Office_Phone: 40,
    SSN_SIN: 11,
    SSN_SIN_C: 11,
    Company_Business_Email: 80,
    Owner_First_Name: 250,
    Owner_Middle_Name: 255,
    Owner_Last_Name: 250,
    Owner_Preferred_First_Name: 255,
    Owner_Preferred_Last_Name: 255,
    Owner_Address1: 200,
    Owner_Address2: 200,
    Owner_City: 200,
    Owner_Postal_Code: 15,
    Owner_Mobile_Phone: 40,
    Owner_Home_Phone: 40,
    Owner_Email: 80,
    HUB_Manager_Contact: 255
  };

  constructor(private route: ActivatedRoute, private elRef: ElementRef, private fb: FormBuilder, private router: Router, private alertService: AlertService, private authService: AuthService, private configurations: ConfigurationService, private sfDataService: SfDataService, private agentService: AgentService, private hintStateService: AiHintStateService) { }



  ngOnInit(): void {


    $('.detailchild').removeClass('active');
    $('.detailmain').removeClass('active');
    $('.detailchild').removeClass('tabhighlight');

    $('#custom-tabs-four-more-tab').removeClass('active');
    $('#custom-tabs-four-more-tab').parent().removeClass('active');
    $('#custom-tabs-four-home-tab').parent().addClass('active');
    $('#custom-tabs-four-home-tab').addClass('active');

    this.id = this.route.snapshot.paramMap.get('id');


    this.q = this.route.snapshot.paramMap.get('query');
    if (this.q != null) {

      this.ShowOTPpopup("Enter Access Code to continue");
      $('#custom-tabs-four-home-tab').parent().addClass('hide');
      $('#custom-tabs-four-profile-tab').parent().addClass('hide');
      $('#custom-tabs-four-more-tab').parent().addClass('hide');
    }


    ////console.log(this.id);
    this.datad = this.inputData;
    this.sendDataToParent();
    this.CreateForm();
    this.BindDropdowns();

    if (this.id != null) {
      if (this.q != null && !this.isOTPValid) {

      }
      else {
        this.idEmitter.emit(this.id);
        this.BindData(this.id);
        this.icdForm.disable();
        this.alertService.showMessage('ICD', `Step 2 needs to be filled out by the ICD`, MessageSeverity.error);

        this.alertService.startLoadingMessage('ICD', 'Step 2 needs to be filled out by the ICD');

        this.btnDisplay = false
      }

    }

  }


  //onFileSelected(event: Event, controlName: string): void {
  //  const input = event.target as HTMLInputElement;
  //  const files = input.files;

  //  if (files) {
  //    const fileArray = Array.from(files); // Convert FileList to Array
  //    const errors: any = {};

  //    // Validate maximum file count
  //    if (fileArray.length > this.maxFiles) {
  //      errors.maxFilesExceeded = true;
  //    }

  //    // Validate each file
  //    fileArray.forEach((file) => {
  //      const fileExtension = file.name.split('.').pop()?.toLowerCase();
  //      if (!this.allowedFormats.includes(fileExtension || '')) {
  //        errors.invalidFormat = true;
  //      }
  //      if (file.size > this.maxFileSize) {
  //        errors.fileSizeExceeded = true;
  //      }
  //    });

  //    // Get the form control
  //    const control = this.icdForm.get(controlName);

  //    if (Object.keys(errors).length > 0) {
  //      // If validation errors exist, set errors and clear input
  //      control?.setErrors(errors);
  //      input.value = ''; // Clear the file input so the user can reselect
  //    } else {
  //      // Clear previous errors
  //      control?.setErrors(null);

  //      // Process and store the files in fileData
  //      fileArray.forEach((file) => {
  //        const reader = new FileReader();
  //        reader.readAsDataURL(file);

  //        reader.onload = () => {
  //          const base64Content = reader.result?.toString().split(',')[1];
  //          if (base64Content) {
  //            this.fileData.push({
  //              attachment_FileName: file.name,
  //              attachment_Base64: base64Content,
  //              attachment_Type: controlName,
  //            });
  //          }
  //        };
  //      });

  //      // Optionally store the file array in the form control (not input.value)
  //      //control?.setValue(fileArray);
  //    }
  //  }
  //}


  isInvalid(controlName: string): boolean {
    const control = this.icdForm.get(controlName);
    return control?.invalid && (control.dirty || control.touched);
  }

  // Handle checkbox change
  onCheckboxChange(event: any, demographic: string) {
    if (event.target.checked) {
      if (demographic === 'Decline to respond') {
        // Selecting "Decline to respond" switches off every other selected toggle.
        this.selectedDemographics = ['Decline to respond'];
      } else {
        // Selecting any other option clears a previously chosen "Decline to respond".
        this.selectedDemographics = this.selectedDemographics.filter(item => item !== 'Decline to respond');
        this.selectedDemographics.push(demographic);
      }
    } else {
      // Remove it if unchecked
      this.selectedDemographics = this.selectedDemographics.filter(item => item !== demographic);
    }

    // Check if the selection is valid
    this.validateSelection();
  }

  // Validation method
  validateSelection() {
    this.isDemographicsInvalid = this.selectedDemographics.length === 0;
  }

  onCheckboxConsentChange(event: any, demographic: string) {
    if (event.target.checked) {
      // Add the demographic to the selected list
      this.isConsentInvalid = false;
    } else {
      // Remove it if unchecked
      this.isConsentInvalid = true;
    }

    // Check if the selection is valid
    this.validateSelection();
  }



  onIsPreferChange(Is_Preferred_Differ) {

    if (Is_Preferred_Differ === 'Yes') {
      this.IsPref_Differ = true;
      this.icdForm.get('Owner_Preferred_First_Name').setValidators([Validators.required]);
      this.icdForm.get('Owner_Preferred_Last_Name').setValidators([Validators.required]);

    } else {
      this.IsPref_Differ = false;
      this.icdForm.get('Owner_Preferred_First_Name').clearValidators();
      this.icdForm.get('Owner_Preferred_Last_Name').clearValidators();

      if (this.icdForm.value.Owner_Preferred_First_Name == null) {
        this.icdForm.controls['Owner_Preferred_First_Name'].setValue(this.icdForm.value.Owner_First_Name);
        this.icdForm.controls['Owner_Preferred_Last_Name'].setValue(this.icdForm.value.Owner_Last_Name);
      }

    }
    this.icdForm.get('Owner_Preferred_First_Name').updateValueAndValidity();
    this.icdForm.get('Owner_Preferred_Last_Name').updateValueAndValidity();

  }

  ShowOTPpopup(str: string) {
    Swal.fire({
      title: 'Access Code!',
      text: str,
      icon: 'warning',
      confirmButtonText: 'Ok',
      allowOutsideClick: false,
      allowEscapeKey: false,
      input: 'text',
      showLoaderOnConfirm: true,  // Show a loading spinner while the API call is in progress
      preConfirm: async (val) => {
        if (!val) {
          Swal.showValidationMessage("Access Code is required");
        } else {
          try {

            // Create a new instance of the ICD class
            let responseAPI = new ResponseAPI();
            this.sfDataService.getOTP(this.id, val, this.q)
              .pipe(takeUntil(this.destroy$))
              .subscribe(
                data => {

                  //responseAPI = data;
                  // Assign the received data to the responseAPI object
                  responseAPI = data;
                  if (responseAPI.isSuccess) {
                    this.isOTPValid = responseAPI.isSuccess;
                    this.idEmitter.emit(this.id);
                    this.BindData(this.id);
                  }
                  else {
                    // API call failed, reject the Promise to prevent closing the popup
                    this.ShowOTPpopup("Wrong Access Code, Enter Access Code to continue");
                  }

                },
                error => {

                  this.alertService.stopLoadingMessage();

                  if (Utilities.checkNoNetwork(error)) {
                    this.alertService.showStickyMessage(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, MessageSeverity.error, error);
                    this.offerAlternateHost();
                  } else {
                    const errorMessage = Utilities.getHttpResponseMessage(error);

                    if (errorMessage) {
                      this.alertService.showStickyMessage('Unable to store data', this.mapLoginErrorMessage(errorMessage), MessageSeverity.error, error);
                    } else {
                      this.alertService.showStickyMessage('Unable to store data', 'An error occured while saving data, please try again later.\nError: ' + Utilities.getResponseBody(error), MessageSeverity.error, error);
                    }
                  }

                  setTimeout(() => {
                    this.isLoading = false;
                  }, 500);
                });

            // await this.apiService.postData(val);
            // API call succeeded, resolve the Promise
          } catch (error) {
            // API call failed, reject the Promise to prevent closing the popup
            return Promise.reject(error);
          }
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        // Handle success case when the API call is successful
      } else if (result.isDenied) {
        // Handle the case when the user cancels the dialog
      } else if (result.isDismissed) {
        // Handle the case when the dialog is closed without confirmation
      }
    });
  }

  Showsuccesspopup(str: string) {
    Swal.fire({
      title: str,
      icon: 'error',
      confirmButtonText: 'Ok',
      allowOutsideClick: false,
      allowEscapeKey: false,

      showLoaderOnConfirm: true,  // Show a loading spinner while the API call is in progress
      preConfirm: async (val) => {
        if (val) {
          //location.reload();
        }
      },
    }).then((result) => {

    });
  }


  Showsuccesspopup1(str: string) {
    Swal.fire({
      title: str,
      icon: 'success',
      confirmButtonText: 'Ok',
      allowOutsideClick: false,
      allowEscapeKey: false,

      showLoaderOnConfirm: true,  // Show a loading spinner while the API call is in progress
      preConfirm: async (val) => {
        if (val) {
          this.router.navigate(["//icddetail/icdinfo/" + this.id + "/RfCXIybmo.5L4V41raLVtQ--/"]);
          //location.reload();
        }
      },
    }).then((result) => {

    });
  }

  CreateForm() {
    this.icdForm = this.fb.group({
      US_or_CA: ['', Validators.required],
      Full_Legal_Company_Name: [{ value: '', disabled: true }],
      Tax_ID: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Tax_ID)]],

      State_of_Incorporation: ['', Validators.required],
      Provinence_of_Incorporation: ['', Validators.required],

      Company_Address1: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Company_Address1), this.noHtmlTagsValidator.bind(this)]],
      Company_Address2: ['', [Validators.maxLength(this.fieldMaxLengths.Company_Address2), this.noHtmlTagsValidator.bind(this)]],
      Company_City: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Company_City), this.noHtmlTagsValidator.bind(this)]],
      Company_Postal_Code: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Company_Postal_Code), postalCodeValidator()]],
      //Company_Office_Phone: ['', Validators.required],
      Company_Office_Phone: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Company_Office_Phone), tenDigitPhoneNumberValidator()]],
      SSN_SIN: ['', [Validators.required, Validators.pattern(this.isUS ? /^\d{9}$/ : /^\d{9}$/)]],
      SSN_SIN_C: ['', [Validators.required, Validators.pattern(this.isUS ? /^\d{9}$/ : /^\d{9}$/)]],

      Company_Business_Email: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Company_Business_Email), Validators.email, this.noHtmlTagsValidator.bind(this)]],
      Company_Country: ['', Validators.required],
      Company_State: ['', Validators.required],
      Company_Province: ['', Validators.required],

      Owner_First_Name: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Owner_First_Name), this.noHtmlTagsValidator.bind(this)]],
      Owner_Last_Name: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Owner_Last_Name), this.noHtmlTagsValidator.bind(this)]],
      Owner_Middle_Name: [{ value: '', disabled: true }, [Validators.maxLength(this.fieldMaxLengths.Owner_Middle_Name), this.noHtmlTagsValidator.bind(this)]],
      Owner_Preferred_First_Name: ['', [Validators.maxLength(this.fieldMaxLengths.Owner_Preferred_First_Name), this.noHtmlTagsValidator.bind(this)]],
      Owner_Preferred_Last_Name: ['', [Validators.maxLength(this.fieldMaxLengths.Owner_Preferred_Last_Name), this.noHtmlTagsValidator.bind(this)]],
      Is_Preferred_Differ: ['', Validators.required],
      Attach_Govt_Issued_ID: ['', [Validators.required]],
      //Attach_Govt_Issued_ID: ['', Validators.required],
      Owner_Perc: [
        '',
        [
          Validators.required,
          Validators.min(1),
          Validators.max(100),
          Validators.pattern('^[0-9]*$') // Only whole numbers allowed
        ]
      ],
      Owner_Address1: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Owner_Address1), this.noHtmlTagsValidator.bind(this)]],
      Owner_Address2: ['', [Validators.maxLength(this.fieldMaxLengths.Owner_Address2), this.noHtmlTagsValidator.bind(this)]],
      Owner_City: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Owner_City), this.noHtmlTagsValidator.bind(this)]],
      Owner_Country: [''],
      Owner_State: ['', Validators.required],
      Owner_Province: ['', Validators.required],
      Owner_Postal_Code: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Owner_Postal_Code), postalCodeValidator()]],
      Owner_Mobile_Phone: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Owner_Mobile_Phone), elevenDigitPhoneNumberValidator()]],
      Owner_Home_Phone: ['', [Validators.maxLength(this.fieldMaxLengths.Owner_Home_Phone), tenDigitPhoneNumberValidator()]],
      Owner_Email: [
        '',
        [
          Validators.required,
          Validators.maxLength(this.fieldMaxLengths.Owner_Email),
          Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/),
          this.noHtmlTagsValidator.bind(this)
        ]
      ],
      Owner_Consent: [''],
      Owner_Demographics: [''],
      HUB_Manager_Contact_Name: [{ value: '', disabled: true }],
      HUB_Manager_Contact_Number: [{ value: '', disabled: true }],
      HUB_Manager_Contact_Email: [{ value: '', disabled: true }],
      HUB_Manager_Contact: ['', [Validators.maxLength(this.fieldMaxLengths.HUB_Manager_Contact), this.noHtmlTagsValidator.bind(this)]],

    }, {
      validators: MustMatch('SSN_SIN', 'SSN_SIN_C')
    });
  }

  preventNonInteger(event: KeyboardEvent) {
    // Allow digits and a single decimal point (e.g. 33.33); block everything else.
    if (event.key === '.') {
      const value = (event.target as HTMLInputElement)?.value ?? '';
      if (value.includes('.')) {
        event.preventDefault();
      }
      return;
    }
    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }



  private getFileExtension(fileName: string): string {
    const fileExtension = fileName.split('.').pop().toLowerCase();
    return fileExtension;
  }


  private getMimeType(fileExtension: string): string {
    // Map the file extension to the corresponding MIME type
    const mimeTypeMap = {
      pdf: 'application/pdf',
      jpg: 'image/jpeg',
      jpeg: 'image/jpeg',
      png: 'image/png'
    };

    return mimeTypeMap[fileExtension];
  }


  //isInvalid(controlName: string): boolean {
  //  const control = this.icdForm.get(controlName);
  //  return control.touched && control.invalid;
  //}


  isValidFileFormat(file: File): boolean {
    const allowedMimePrefixes = [
      'image/' // all image types (jpg, png, heic, webp, etc.)
    ];

    const allowedExactMimeTypes = [
      // PDF
      'application/pdf',

    ];

    // 1️⃣ Primary check (modern browsers)
    if (file.type) {
      if (allowedMimePrefixes.some(prefix => file.type.startsWith(prefix))) {
        return true;
      }

      if (allowedExactMimeTypes.includes(file.type)) {
        return true;
      }
    }

    // 2️⃣ Fallback (Safari / iOS / older browsers)
    const allowedExtensions = [
      // images
      'jpg', 'jpeg', 'png', 'gif', 'webp', 'heic', 'heif',

     
    ];

    const extension = file.name.split('.').pop()?.toLowerCase();
    return !!extension && allowedExtensions.includes(extension);
  }



  fileValidator(control: any) {
    const files = control.value;

    if (!files || files.length === 0) {
      return null;
    }

    if (files.length + this.fileData.length > this.maxFilesAllowed) {
      return { maxFilesExceeded: true };
    }

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (!this.isValidFileFormat(file)) {
        return { invalidFormat: true };
      }

      if (file.size > this.maxFileSize) {
        return { fileSizeExceeded: true };
      }
    }

    return null;
  }

  sendDataToParent() {
    this.dataEmitter.emit(this.datad);
  }
  // convenience getter for easy access to form fields
  get f() { return this.icdForm.controls; }

  integerValidator(control: AbstractControl) {
    const value = control.value;
    if (value && !Number.isInteger(+value)) {
      return { integer: true };
    }
    return null;
  }

  preventDecimal(event: KeyboardEvent) {
    if (event.key === '.' || event.key === ',') {
      event.preventDefault();
    }
  }


  onCountryChange() {
    const US_or_CA = this.icdForm.get('US_or_CA').value;
    if (US_or_CA === 'US') {
      this.selectedCountry = "US";
      this.isUS = true;
      this.icdForm.get('State_of_Incorporation').setValidators([Validators.required]);
      this.icdForm.get('Provinence_of_Incorporation').clearValidators();

      //this.icdForm.get('Owner_Country').setValidators([Validators.required]);
      this.icdForm.get('Owner_State').setValidators([Validators.required]);
      this.icdForm.get('Owner_Province').clearValidators();

      this.icdForm.get('Company_Country').setValidators([Validators.required]);
      this.icdForm.get('Company_State').setValidators([Validators.required]);
      this.icdForm.get('Company_Province').clearValidators();

      this.demographicsData = [
        'Asian-Indian', 'Asian-Pacific', 'Black or African-American', 'Hispanic', 'Native American',
        'Woman/Women', 'LGBTQ+', 'Veteran', 'None Apply', 'Decline to respond'
      ];

    } else {
      this.selectedCountry = "Canada";
      this.isUS = false;
      this.icdForm.get('Provinence_of_Incorporation').setValidators([Validators.required]);
      this.icdForm.get('State_of_Incorporation').clearValidators();


      //this.icdForm.get('Owner_Country').clearValidators();
      this.icdForm.get('Owner_State').clearValidators();
      this.icdForm.get('Owner_Province').setValidators([Validators.required]);

      this.icdForm.get('Company_Country').clearValidators();
      this.icdForm.get('Company_State').clearValidators();
      this.icdForm.get('Company_Province').setValidators([Validators.required]);

      this.demographicsData = [
        'Asian-Indian', 'Asian-Pacific', 'Black or African-American', 'Hispanic', 'Native American',
        'Woman/Women', 'LGBTQ+', 'Veteran', 'None Apply', 'Decline to respond', 'Indigenous Peoples'
      ];

    }
    this.icdForm.get('Provinence_of_Incorporation').updateValueAndValidity();
    this.icdForm.get('State_of_Incorporation').updateValueAndValidity();


    //this.icdForm.get('Owner_Country').updateValueAndValidity();
    this.icdForm.get('Owner_State').updateValueAndValidity();
    this.icdForm.get('Owner_Province').updateValueAndValidity();

    this.icdForm.get('Company_Country').updateValueAndValidity();
    this.icdForm.get('Company_State').updateValueAndValidity();
    this.icdForm.get('Company_Province').updateValueAndValidity();
    this.icdForm.get('Company_Postal_Code').updateValueAndValidity();
    this.icdForm.get('Owner_Postal_Code').updateValueAndValidity();
  }

  showErrorAlert(caption: string, message: string) {
    this.alertService.showMessage(caption, message, MessageSeverity.error);
  }


  onInputChange(value: string) {

    let sanitizedValue = value.replace(/\D/g, '');


    if (sanitizedValue.length > 9) {
      sanitizedValue = sanitizedValue.slice(0, 9);
    }


    this.icdForm.get('SSN_SIN')?.setValue(sanitizedValue);
    this.displayValue = sanitizedValue;
  }


  onBlur() {
    const value = this.icdForm.get('SSN_SIN')?.value || '';
    this.displayValue = this.maskSSN(value);
  }


  onFocus() {
    this.displayValue = this.icdForm.get('SSN_SIN')?.value || '';
  }

  maskSSN(value: string): string {
    if (value) {
      const sanitizedValue = value.replace(/\D/g, '');

      if (this.isUS && sanitizedValue.length === 9) {
        return 'XXX-XX-' + sanitizedValue.slice(-4);
      } else if (!this.isUS && sanitizedValue.length === 9) {

        return 'XXX-XXX-' + sanitizedValue.slice(-3);
      }
    }

    return value; // If less than 9 digits, return as is
  }


  //onFileSelected(event: any, controlName: string) {
  //  const files = event.target.files;
  //  const errors = [];

  //  // Clear previous file data for this control
  //  this.fileData = this.fileData.filter(file => file.attachment_Type !== controlName);

  //  for (let i = 0; i < files.length; i++) {
  //    const file = files[i];

  //    // Check for valid file format
  //    if (!this.isValidFileFormat(file)) {
  //      //console.log('Invalid file format:', file.name);
  //      errors.push({ invalidFormat: true });
  //    }

  //    // Check for file size limit
  //    if (file.size > this.maxFileSize) {
  //      //console.log('File size exceeds the limit:', file.name);
  //      errors.push({ fileSizeExceeded: true });
  //    }
  //  }

  //  // Set errors if any are found
  //  if (errors.length > 0) {
  //    this.icdForm.get(controlName).setErrors(errors.reduce((acc, curr) => ({ ...acc, ...curr }), {}));
  //  } else {
  //    // If there are no errors, process files and add them to fileData
  //    for (let i = 0; i < files.length; i++) {
  //      const file = files[i];

  //      const reader = new FileReader();
  //      reader.readAsDataURL(file);

  //      reader.onload = () => {
  //        const b64 = reader.result.toString().split(',')[1];
  //        this.fileData.push({ attachment_FileName: file.name, attachment_Base64: b64, attachment_Type: controlName });
  //      };
  //    }

  //    // Clear errors if validation passes
  //    this.icdForm.get(controlName).setErrors(null);
  //  }

  //  // Update validity to ensure the form reflects changes
  //  this.icdForm.get(controlName).updateValueAndValidity();
  //}


  onFileSelected(event: any, controlName: string) {
    const files = event.target.files;
    const errorMessages: string[] = [];
    //this.isFileProcessing = true; // Start processing

    if (!files || files.length === 0) {
      this.fileData = this.fileData.filter(file => file.attachment_Type !== controlName);
      this.icdForm.get(controlName).setErrors({ noFileSelected: true });
      this.isFileProcessing = false; // End processing
      return;
    }

    this.fileData = this.fileData.filter(file => file.attachment_Type !== controlName);

    const file = files[0];
    const errors = [];

    if (!this.isValidFileFormat(file)) {
      errorMessages.push(
        `Invalid file format for "${file.name}". 
     Allowed formats: all image files (JPG, PNG, HEIC, etc.) or PDF.`
      );

      errors.push({ invalidFormat: true });
    }

    if (file.size > this.maxFileSize) {
      errorMessages.push(`File size exceeds 25 MB limit for file "${file.name}".`);
      errors.push({ fileSizeExceeded: true });
    }

    if (errors.length > 0) {
      const combinedMessage = errorMessages.join('\n');

      this.alertService.showMessage(combinedMessage, '.', MessageSeverity.error);
      this.Showsuccesspopup(combinedMessage);
      this.icdForm.get(controlName).setErrors(errors.reduce((acc, curr) => ({ ...acc, ...curr }), {}));
      const control = this.icdForm.get(controlName);
      // 🔥 CRITICAL FIX
      control?.setValue(null);
      control?.setErrors(errors.reduce((acc, curr) => ({ ...acc, ...curr }), {}));
      control?.markAsTouched();
      control?.updateValueAndValidity({ emitEvent: false });

      // optional: clear DOM input too
      event.target.value = '';
      return; // 👈 stop here
      this.isFileProcessing = false;
    } else {
      // SUCCESS: upload the file to staging on select (FR1)
      this.uploadState[controlName] = 'uploading';
      this.uploadError[controlName] = '';
      const inputEl = event.target as HTMLInputElement;
      // Bump the selection counter; a superseded selection's FileReader result is discarded (FR2).
      const seq = this.uploadSeq[controlName] = (this.uploadSeq[controlName] || 0) + 1;

      const reader = new FileReader();

      reader.onload = () => {
        if (this.uploadSeq[controlName] !== seq) { return; } // a newer selection superseded this one
        const b64 = reader.result.toString().split(',')[1];
        const entry: { attachment_FileName: string, attachment_Base64: string, attachment_Type: string, FileId?: string, Url?: string, status?: 'uploading' | 'uploaded' | 'error' } = {
          attachment_FileName: file.name,
          attachment_Base64: b64,
          attachment_Type: controlName,
          status: 'uploading'
        };
        this.fileData.push(entry);
        this.triggerDocumentVerification(controlName);
        this.stageFile(entry, controlName, inputEl);

        this.icdForm.get(controlName).setErrors(null);
        this.isFileProcessing = true; // Done
      };

      reader.readAsDataURL(file);
    }
  }

  // Uploads a single file to the staging area. A response from a previously replaced/cancelled
  // upload is ignored via object identity: if the entry is no longer in fileData, discard it (FR2).
  private stageFile(entry: any, controlName: string, inputEl: HTMLInputElement): void {
    // Owner name / Tax ID must come from the live form (populated on load), not this.icd
    // (only filled in saveData() at submit). Otherwise the DocPortal "Name" sent at staging
    // ("<owner> <taxId> <caseId>") won't match the one the confirm/move rebuilds at submit,
    // and the file is never moved out of staging.
    const firstName = this.icdForm?.get('Owner_First_Name')?.value || this.icd?.Owner_First_Name || '';
    const lastName = this.icdForm?.get('Owner_Last_Name')?.value || this.icd?.Owner_Last_Name || '';
    const body = {
      CaseID: this.icd?.CaseID || this.icd?.AccountID || '',
      Attachment_FileName: entry.attachment_FileName,
      Attachment_Base64: entry.attachment_Base64,
      Owner_Email: this.icdForm?.get('Owner_Email')?.value || this.icd?.Owner_Email || this.icdForm?.get('Company_Business_Email')?.value || this.icd?.Company_Business_Email || this.icdForm?.get('HUB_Manager_Contact_Email')?.value || this.icd?.HUB_Manager_Contact_Email || this.icd?.HUB_Assistance_Email || '',
      Owner_Name: (firstName + ' ' + lastName).trim(),
      Tax_ID: this.icdForm?.get('Tax_ID')?.value || this.icd?.Tax_ID || ''
    };

    entry.StagingUniqueId = body.CaseID;

    // Step 2 is an anonymous emailed-link flow -> use the [AllowAnonymous] SFStep2 endpoint.
    this.sfDataService.stageAttachmentStep2(body).subscribe({
      next: (res: any) => {
        if (!this.fileData.includes(entry)) { return; } // superseded by a newer selection (FR2)
        if (res && res.isSuccess) {
          entry.FileId = res.fileId;
          entry.Url = res.url;
          entry.status = 'uploaded';
        } else {
          entry.status = 'error';
          this.removeStagedEntry(entry, inputEl);
          this.uploadError[controlName] = (res && res.errorMessage) ? res.errorMessage : 'Upload failed — please re-select the file.';
        }
        this.recomputeUploadState(controlName);
      },
      error: (err: any) => {
        if (!this.fileData.includes(entry)) { return; }
        entry.status = 'error';
        this.removeStagedEntry(entry, inputEl);
        this.uploadError[controlName] = this.extractServerError(err);
        this.recomputeUploadState(controlName);
      }
    });
  }

  // FR5: a failed file must not be silently submitted — drop it and force a re-select.
  private removeStagedEntry(entry: any, inputEl: HTMLInputElement): void {
    this.fileData = this.fileData.filter(f => f !== entry);
    const control = this.icdForm.get(entry.attachment_Type);
    if (inputEl) { inputEl.value = ''; }
    if (control?.hasValidator?.(Validators.required)) {
      control.setErrors({ required: true });
    }
    control?.markAsTouched();
  }

  private recomputeUploadState(controlName: string): void {
    const entries = this.fileData.filter(f => f.attachment_Type === controlName);
    if (entries.some(e => e.status === 'uploading')) {
      this.uploadState[controlName] = 'uploading';
    } else if (entries.length > 0 && entries.every(e => e.status === 'uploaded')) {
      this.uploadState[controlName] = 'uploaded';
      this.uploadError[controlName] = '';
    } else if (entries.length === 0 && this.uploadError[controlName]) {
      this.uploadState[controlName] = 'error';
    } else if (entries.length === 0) {
      delete this.uploadState[controlName];
    }
  }

  private extractServerError(err: any): string {
    try {
      if (err?.error?.errorMessage) { return err.error.errorMessage; }
      if (typeof err?.error === 'string' && err.error) { return err.error; }
      if (err?.message) { return err.message; }
    } catch { /* ignore */ }
    return 'Upload failed — please re-select the file.';
  }

  // FR1: block submission while any staged upload is still resolving.
  hasUploadsInFlight(): boolean {
    return this.fileData.some(f => f.status === 'uploading');
  }



  onInputChange_C(value: string) {

    let sanitizedValue = value.replace(/\D/g, '');


    if (sanitizedValue.length > 9) {
      sanitizedValue = sanitizedValue.slice(0, 9);
    }


    this.icdForm.get('SSN_SIN_C')?.setValue(sanitizedValue);
    this.displayValue_C = sanitizedValue;
  }


  onBlur_C() {
    const value = this.icdForm.get('SSN_SIN_C')?.value || '';
    this.displayValue_C = this.maskSSN(value);
  }


  onFocus_C() {
    this.displayValue_C = this.icdForm.get('SSN_SIN_C')?.value || '';
  }

  maskSSN_C(value: string): string {
    if (value) {
      const sanitizedValue = value.replace(/\D/g, '');

      if (this.isUS && sanitizedValue.length === 9) {
        return 'XXX-XX-' + sanitizedValue.slice(-4);
      } else if (!this.isUS && sanitizedValue.length === 9) {

        return 'XXX-XXX-' + sanitizedValue.slice(-3);
      }
    }

    return value; // If less than 9 digits, return as is
  }

  ngAfterViewInit() {

    //if (this.selectEl) {
    //  $(this.selectEl.nativeElement).select2({ width: '100%' });
    //};

    setTimeout(() => {
      /*$('.select2', this.elRef.nativeElement).select2();*/
    }, 0);
    //$('.select2').select();
    //$(this.datepicker.nativeElement).datepicker({
    //  dateFormat: 'yyyy-mm-dd',
    //  autoclose: true,
    //  onSelect: (date) => {
    //    this.dobInput.nativeElement.value = date;
    //  }
    //});

    //$('.select2').select2(); //initialize 
  }

  closeModal() {
    if (this.modalClosedCallback) {
      this.modalClosedCallback();
    }
  }

  onSubmit() {
    this.hintStateService.collapse();

    this.submitted = true;

    // FR1: do not submit while a file is still uploading to staging.
    if (this.hasUploadsInFlight()) {
      this.alertService.showMessage('Please wait', 'A file is still uploading. Please wait until it finishes before submitting.', MessageSeverity.error);
      return;
    }

    this.trimFormValues();

    if (this.fileData.length <= 0) {
      this.alertService.showMessage('ICD', 'Government issued photo ID is required.', MessageSeverity.error);
      this.Showsuccesspopup('Government issued photo ID is required.');
      return;
    }

    // stop here if form is invalid
    if (this.icdForm.invalid) {


      const formControls = this.icdForm.controls;

      // Initialize an array to store invalid controls
      const invalidControls: string[] = [];

      // Iterate through the form controls and check if they are invalid
      Object.keys(formControls).forEach(controlName => {
        const control = this.icdForm.get(controlName);

        if (control?.invalid) {
          let displayName =
            this.controlDisplayNames[controlName] || controlName;

          if (control.errors?.invalidHtml) {
            displayName += ' (HTML/script not allowed)';
          }
          invalidControls.push(displayName);
        }
      });

      // Now, the 'invalidControls' array contains the names of all invalid form controls
      ////console.log('Invalid controls:', invalidControls);
      const commaSeparated = invalidControls.join(', ');

      // Mark all fields as touched to display validation errors
      this.icdForm.markAllAsTouched();
      this.alertService.showMessage('Enter required fields', commaSeparated, MessageSeverity.error);
      this.Showsuccesspopup('Enter required fields :' + commaSeparated);
      if (this.icdForm.value.Owner_Consent != true) {
        //this.saveData();

        this.isConsentInvalid = true;
        this.alertService.showMessage('ICD', `Consent is required, Please select the checkbox`, MessageSeverity.error);
        this.Showsuccesspopup('Consent is required, Please select the checkbox');
      }





      if (this.selectedDemographics.length === 0) {
        this.isDemographicsInvalid = true;
        this.alertService.showMessage('ICD', `Demographics is required, Please select the checkbox`, MessageSeverity.error);
        this.Showsuccesspopup('Demographics is required, Please select the checkbox');
      }
      return;
    }

    if (this.icdForm.value.Owner_Consent == true && this.selectedDemographics.length > 0) {


      if (!this.isFileProcessing) {
        this.alertService.showMessage('ICD', 'File is still uploading. Please wait...', MessageSeverity.error);
        this.Showsuccesspopup('File is still uploading. Please wait...');
        return;
      }

      this.showPreSubmitReview = true;
      this.runPreSubmitReview();
    }
    else {
      if (this.icdForm.value.Owner_Consent != true) {
        this.isConsentInvalid = true;
        this.alertService.showMessage('ICD', `Consent is required, Please select the checkbox`, MessageSeverity.error);
        this.Showsuccesspopup('Consent is required, Please select the checkbox');
      }

      if (this.selectedDemographics.length === 0) {
        this.isDemographicsInvalid = true;
        this.alertService.showMessage('ICD', `Demographics is required, Please select the checkbox`, MessageSeverity.error);
        this.Showsuccesspopup('Demographics is required, Please select the checkbox');
      }
      return;
    }


  }

  saveData() {
    //debugger;
    this.isLoading = true;

    this.btnDisplay = false;
    this.alertService.startLoadingMessage('', 'Data Submitting...');

    // Get the form values as an object
    const formValues = this.icdForm.getRawValue();


    // Create a new instance of the ICD class
    let responseAPI = new ResponseAPI();

    // Set the properties of the ICD instance with the form values
    this.icd.US_or_CA = formValues.US_or_CA;
    this.icd.Full_Legal_Company_Name = formValues.Full_Legal_Company_Name;
    this.icd.Tax_ID = formValues.Tax_ID;

    this.icd.Company_Address1 = formValues.Company_Address1;
    this.icd.Company_Address2 = formValues.Company_Address2;
    this.icd.Company_City = formValues.Company_City;
    this.icd.Company_Postal_Code = formValues.Company_Postal_Code;
    this.icd.Company_Office_Phone = formValues.Company_Office_Phone;
    this.icd.Company_Business_Email = formValues.Company_Business_Email;
    this.icd.Company_Country = formValues.Company_Country;
    this.icd.Company_State = formValues.Company_State;
    this.icd.Company_Province = formValues.Company_Province;

    this.icd.Preferred_Name_Different_from_Legal_Name__c = formValues.Is_Preferred_Differ;
    this.icd.Owner_First_Name = formValues.Owner_First_Name;
    this.icd.Owner_Last_Name = formValues.Owner_Last_Name;
    this.icd.Owner_Middle_Name = formValues.Owner_Middle_Name;

    this.icd.Owner_Preferred_First_Name = formValues.Owner_Preferred_First_Name;
    this.icd.Owner_Preferred_Last_Name = formValues.Owner_Preferred_Last_Name;
    this.icd.Owner_Perc = formValues.Owner_Perc;
    this.icd.Owner_Address1 = formValues.Owner_Address1;
    this.icd.Owner_Address2 = formValues.Owner_Address2;
    this.icd.Owner_City = formValues.Owner_City;
    this.icd.Owner_Country = formValues.Owner_Country;
    this.icd.Owner_State = formValues.Owner_State;
    this.icd.Owner_Province = formValues.Owner_Province;
    this.icd.Owner_Postal_Code = formValues.Owner_Postal_Code;
    this.icd.Owner_Office_Phone = formValues.Owner_Mobile_Phone;
    this.icd.Owner_Home_Phone = formValues.Owner_Home_Phone;
    this.icd.Owner_Email = formValues.Owner_Email;
    this.icd.SSN_SIN = formValues.SSN_SIN;

    this.icd.Owner_Demographics = this.selectedDemographics.join(', ');
    if (formValues.Owner_Consent == true) {
      this.icd.Owner_Consent = "yes";
    }

    //this.icd.HUB_Manager_Contact_Name = formValues.HUB_Manager_Contact_Name;
    //this.icd.HUB_Manager_Contact_Number = formValues.HUB_Manager_Contact_Number;
    //this.icd.HUB_Manager_Contact_Email = formValues.HUB_Manager_Contact_Email;
    //this.icd.HUB_Manager_Contact = formValues.HUB_Manager_Contact;

    if (this.icd.US_or_CA == "US") {
      this.icd.State_of_Incorporation = formValues.State_of_Incorporation;
      this.icd.Provinence_of_Incorporation = "";
    }
    else {
      this.icd.Provinence_of_Incorporation = formValues.Provinence_of_Incorporation;
      this.icd.State_of_Incorporation = "";
    }


    const attachCanadaFields = [
      'Attach_Govt_Issued_ID',

    ];

    for (const field of attachCanadaFields) {
      const filteredBase64Array = this.fileData
        .filter(file => file.attachment_Type === field)
        .map(file => file.attachment_Base64);

      const commaSeparatedBase64 = filteredBase64Array.join('$$$');

      this.icd[field] = commaSeparatedBase64;
    }





    this.icd.Attachments = this.fileData.filter(f => f.status === 'uploaded');

    Swal.fire({
      title: 'Submitting data...',
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
    this.sfDataService.CreateICDStep2(this.icd)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        data => {
          Swal.close();
          //responseAPI = data;
          // Assign the received data to the responseAPI object
          responseAPI = data;
          if (responseAPI.isSuccess && !responseAPI.isValidationError) {

            setTimeout(() => {
              window.scrollTo({ top: 0, behavior: 'smooth' });
              this.alertService.showMessage('ICD', `Data Saved Successfully`, MessageSeverity.success);
              this.alertService.stopLoadingMessage();
              this.isLoading = false;
              //this.reset();
              // location.reload();
              //this.icdForm.disable();
              // Iterate over each control and set the 'disabled' attribute to 'true'
              //Object.keys(this.icdForm.controls).forEach(key => {
              //  const control = this.icdForm.get(key);
              //  control?.disable({ onlySelf: true, emitEvent: false }); // Disable the control
              //  control?.updateValueAndValidity(); // Update validity
              //  control?.setErrors(null);
              //});


              this.btnDisplay = false;
              this.Showsuccesspopup1('Data Saved Successfully');
              this.alertService.showStickyMessage('ICD', 'Step 2 is Completed', MessageSeverity.success);

              //this.icdForm.markAsPristine();
              //this.icdForm.markAsUntouched();
              //this.icdForm.updateValueAndValidity();
              //this.icdForm.disable();

              this.setFormReadOnly(true);




            }, 200);
          }
          else {
            this.alertService.stopLoadingMessage();
            this.isLoading = false;
            this.btnDisplay = true;

            // FR6: surface the real server message (e.g. document move/confirm failure) rather
            // than a generic error, and guard against a missing ErrorList payload.
            const serverMessage = responseAPI.description
              || (responseAPI.data && responseAPI.data.error && responseAPI.data.error.message)
              || 'An error occurred while saving data. Please try again.';
            const errorCode = (responseAPI.data && responseAPI.data.error && responseAPI.data.error.errorCode) || '';

            this.alertService.showMessage('ICD', 'Submission failed', MessageSeverity.error);
            this.alertService.showStickyMessage('Unable to store data', serverMessage, MessageSeverity.error, errorCode);
          }

        },
        error => {
          Swal.close();
          this.alertService.stopLoadingMessage();

          if (Utilities.checkNoNetwork(error)) {
            this.alertService.showStickyMessage(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, MessageSeverity.error, error);
            this.offerAlternateHost();
          } else {
            const errorMessage = Utilities.getHttpResponseMessage(error);

            if (errorMessage) {
              this.alertService.showStickyMessage('Unable to store data', this.mapLoginErrorMessage(errorMessage), MessageSeverity.error, error);
            } else {
              this.alertService.showStickyMessage('Unable to store data', 'An error occured while saving data, please try again later.\nError: ' + Utilities.getResponseBody(error), MessageSeverity.error, error);
            }
          }

          setTimeout(() => {
            this.isLoading = false;
          }, 500);
        });
  }


  setFormReadOnly(readonly: boolean) {
    Object.keys(this.icdForm.controls).forEach(key => {
      const element = document.querySelector(
        `[formControlName="${key}"]`
      );

      if (!element) return;

      if (element instanceof HTMLSelectElement) {
        element.disabled = readonly; // selects
      }

      if (element instanceof HTMLInputElement || element instanceof HTMLTextAreaElement) {
        element.readOnly = readonly; // inputs & textareas
      }
    });
  }

  BindDropdowns() {
    //debugger;
    this.isLoading = true;
    this.alertService.startLoadingMessage('', 'Data loading...');

    //this.icd.Owner_Email = this.icdForm.value["Owner_email"];
    this.sfDataService.getMasterConfigs("US_State,Canada_Province")
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        data => {
          ////console.log(data);
          //debugger;
          this.masterConfig = data;
          this.ddlUSStates = this.masterConfig.filter(a => a.type == "US_State");
          this.ddlCAProvinence = this.masterConfig.filter(a => a.type == "Canada_Province");
          this.alertService.stopLoadingMessage();
        },
        error => {

          this.alertService.stopLoadingMessage();

          if (Utilities.checkNoNetwork(error)) {
            this.alertService.showStickyMessage(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, MessageSeverity.error, error);
            this.offerAlternateHost();
          } else {
            const errorMessage = Utilities.getHttpResponseMessage(error);

            if (errorMessage) {
              this.alertService.showStickyMessage('Unable to get data', this.mapLoginErrorMessage(errorMessage), MessageSeverity.error, error);
            } else {
              this.alertService.showStickyMessage('Unable to get data', 'An error occured while saving data, please try again later.\nError: ' + Utilities.getResponseBody(error), MessageSeverity.error, error);
            }
          }

          setTimeout(() => {
            this.isLoading = false;
          }, 500);
        });
  }


  toggleMiddleName(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    const middleName = this.icdForm.get('Owner_Middle_Name');
    if (isChecked) {
      // "No Middle Name" — waive the field: clear value/validators and disable.
      this.noMiddleName = true;
      middleName.setValue('');
      middleName.clearValidators();
      middleName?.disable();
    } else {
      // Middle name required again — re-enable and restore the full validator set.
      this.noMiddleName = false;
      middleName?.enable();
      middleName.setValidators([Validators.required, Validators.maxLength(this.fieldMaxLengths.Owner_Middle_Name), this.noHtmlTagsValidator.bind(this)]);
    }
    middleName.updateValueAndValidity();
  }

  private mapDataToICD(data: any) {
    if (data == null) {

      this.icdForm.disable();
      this.alertService.showMessage('ICD', `This Case is not assigned to view`, MessageSeverity.error);
      this.alertService.startLoadingMessage('', 'This Case is not assigned to view');
      this.alertService.showStickyMessage('ICD', 'This Case is not assigned to view', MessageSeverity.error, "");
      this.btnDisplay = false;

      return;
    }
    //debugger;
    this.icdForm.controls['US_or_CA'].setValue(data.uS_or_CA);
    this.onCountryChange();
    this.icdForm.controls['Full_Legal_Company_Name'].setValue(data.full_Legal_Company_Name);
    this.icdForm.controls['Tax_ID'].setValue(data.tax_ID);
    this.icdForm.controls['State_of_Incorporation'].setValue(data.state_of_Incorporation);
    this.icdForm.controls['Provinence_of_Incorporation'].setValue(data.provinence_of_Incorporation);

    this.icdForm.controls['HUB_Manager_Contact_Email'].setValue(data.huB_Manager_Contact_Email);


    this.icdForm.controls['Company_Address1'].setValue(data.homeAddress);
    this.icdForm.controls['Company_Address2'].setValue(data.homeAddress2);
    this.icdForm.controls['Company_City'].setValue(data.homeCity);
    this.icdForm.controls['Company_Postal_Code'].setValue(data.homeZipCode);
    this.icdForm.controls['Company_Office_Phone'].setValue(data.homePhone);
    this.icdForm.controls['Company_Business_Email'].setValue(data.company_Business_Email);
    this.icdForm.controls['Company_Country'].setValue(data.homeCountry);
    this.icdForm.controls['Company_State'].setValue(data.homeState);
    this.icdForm.controls['Company_Province'].setValue(data.homeState);

    this.icdForm.controls['Owner_First_Name'].setValue(data.owner_First_Name);
    this.icdForm.controls['Owner_Last_Name'].setValue(data.owner_Last_Name);
    this.icdForm.controls['Owner_Middle_Name'].setValue(data.owner_Middle_Name);
    this.secondaryOwner = data.secondary_Owner || ''; // Feature 10

    // Restore the "No Middle Name" toggle state from the loaded record.
    if (data.owner_Middle_Name != null && data.owner_Middle_Name !== '') {
      this.noMiddleName = false;
      this.icdForm.get('Owner_Middle_Name')?.enable();
      this.icdForm.get('Owner_Middle_Name').setValidators([Validators.required, Validators.maxLength(this.fieldMaxLengths.Owner_Middle_Name), this.noHtmlTagsValidator.bind(this)]);
    } else {
      this.noMiddleName = true;
      this.icdForm.get('Owner_Middle_Name').clearValidators();
      this.icdForm.get('Owner_Middle_Name')?.disable();
    }
    this.icdForm.get('Owner_Middle_Name').updateValueAndValidity();
    const rawSsn = (data.ssN_SIN || '').replace(/\D/g, '').slice(0, 9);
    this.icdForm.controls['SSN_SIN'].setValue(rawSsn);
    this.displayValue = this.maskSSN(rawSsn);



    if (data.preferred_Name_Different_from_Legal_Name__c == "true") {
      this.icdForm.controls['Is_Preferred_Differ'].setValue('Yes');
      this.onIsPreferChange('Yes');
    }
    else {
      this.icdForm.controls['Is_Preferred_Differ'].setValue('No');
      this.onIsPreferChange('No');
    }
    this.icdForm.controls['Owner_Preferred_First_Name'].setValue(data.owner_Preferred_First_Name);
    this.icdForm.controls['Owner_Preferred_Last_Name'].setValue(data.owner_Preferred_Last_Name);
    this.icdForm.controls['Owner_Perc'].setValue(data.ownership ? Math.trunc(data.ownership) : 0);
    this.icdForm.controls['Owner_Address1'].setValue(data.owner_Address1);
    this.icdForm.controls['Owner_Address2'].setValue(data.owner_Address2);
    this.icdForm.controls['Owner_City'].setValue(data.owner_City);
    this.icdForm.controls['Owner_Country'].setValue(data.owner_Country);
    this.icdForm.controls['Owner_State'].setValue(data.state);
    this.icdForm.controls['Owner_Province'].setValue(data.state);
    this.icdForm.controls['Owner_Postal_Code'].setValue(data.zipCode);
    this.icdForm.controls['Owner_Mobile_Phone'].setValue(data.owner_Office_Phone);
    this.icdForm.controls['Owner_Home_Phone'].setValue(data.owner_Home_Phone);
    this.icdForm.controls['Owner_Email'].setValue(data.owner_Email);

    this.icdForm.controls['HUB_Manager_Contact_Name'].setValue(data.huB_Manager_Contact_Name);
    this.icdForm.controls['HUB_Manager_Contact_Number'].setValue(data.huB_Manager_Contact_Number);


    this.icd.AccountID = data.accountID;
    this.icd.HUB_Manager_Contact = data.huB_Manager_Contact;
    this.icd.HUB_Manager_Contact_Name = data.huB_Manager_Contact_Name;
    this.icd.HUB_Manager_Contact_Number = data.huB_Manager_Contact_Number;
    this.icd.HUB_Manager_Contact_Email = data.huB_Manager_Contact_Email;
    this.icd.HUB_Assistance_Email = data.huB_Assistance_Email;

    
    this.icd.CaseID = data.caseID;
    this.icd.ContactID = data.contactID;
    if (data.icdInfoReceivedOn != null) {
      this.icd.ICDInfoReceivedOn = data.icdInfoReceivedOn;
      this.alertService.showStickyMessage('ICD', 'Step 2 Already Completed', MessageSeverity.warn);      
      this.icdForm.disable();
      this.alertService.showMessage('ICD', `Step 2 Already Completed`, MessageSeverity.success);
      this.alertService.startLoadingMessage('', 'Step 2 Already Completed');
      this.Showsuccesspopup('ICD Step 2 Already Completed');
      this.btnDisplay = false;
    }
    this.dataEmitter.emit(this.datad);


  }

  BindData(id: string) {
    //debugger;

    this.isLoading = true;
    this.alertService.startLoadingMessage('', 'Data loading...');
    //this.icd.Owner_Email = this.icdForm.value["Owner_email"];
    this.sfDataService.getICD(id)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        data => {
          //console.log(data);
          //debugger;

          this.mapDataToICD(data);
          ////console.log(data);


          this.alertService.stopLoadingMessage();
        },
        error => {

          this.alertService.stopLoadingMessage();

          if (Utilities.checkNoNetwork(error)) {
            this.alertService.showStickyMessage(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, MessageSeverity.error, error);
            this.offerAlternateHost();
          } else {
            const errorMessage = Utilities.getHttpResponseMessage(error);

            if (errorMessage) {
              this.alertService.showStickyMessage('Unable to get data', this.mapLoginErrorMessage(errorMessage), MessageSeverity.error, error);
            } else {
              this.alertService.showStickyMessage('Unable to get data', 'An error occured while saving data, please try again later.\nError: ' + Utilities.getResponseBody(error), MessageSeverity.error, error);
            }
          }

          setTimeout(() => {
            this.isLoading = false;
          }, 500);
        });
  }

  mapLoginErrorMessage(error: string) {

    if (error === 'invalid_username_or_password') {
      return 'Invalid username or password';
    }

    if (error === 'invalid_grant') {
      return 'This account has been disabled';
    }

    return error;
  }

  offerAlternateHost() {

    if (Utilities.checkIsLocalHost(location.origin) && Utilities.checkIsLocalHost(this.configurations.baseUrl)) {
      this.alertService.showDialog('Dear Developer!\nIt appears your backend Web API service is not running...\n' +
        'Would you want to temporarily switch to the online Demo API below?(Or specify another)',
        DialogType.prompt,
        (value: string) => {
          this.configurations.baseUrl = value;
          this.alertService.showStickyMessage('API Changed!', 'The target Web API has been changed to: ' + value, MessageSeverity.warn);
        },
        null,
        null,
        null,
        this.configurations.fallbackBaseUrl);
    }
  }

  trimFormValues() {
    // Don't attempt to set the value of file input controls programmatically
    // (browsers only allow setting input[type=file].value to an empty string)
    const fileControls = ['Attach_Govt_Issued_ID'];

    // SSN/SIN fields display a masked value via [value]="displayValue" while
    // also using formControlName. Calling setValue() here makes the reactive
    // forms value accessor write the raw digits back into the DOM, un-masking
    // the field on submit. Their values are already digit-only (sanitized in
    // onInputChange), so trimming is a no-op — skip them to preserve the mask.
    const maskedControls = ['SSN_SIN', 'SSN_SIN_C'];

    Object.keys(this.icdForm.controls).forEach(key => {
      if (fileControls.includes(key) || maskedControls.includes(key)) {
        return; // skip file inputs and masked SSN/SIN fields
      }

      const control = this.icdForm.get(key);

      // Only trim string values. Guard setValue with try/catch to avoid
      // InvalidStateError if a control is bound to a native file input.
      if (control && typeof control.value === 'string') {
        try {
          control.setValue(control.value.trim());
        } catch (e) {
          // Log and continue — don't let a single control break the form
          console.warn(`trimFormValues: skipped trimming control '${key}' due to error`, e);
        }
      }
    });
  }

  noHtmlTagsValidator(control: any) {

    if (!control.value) {
      return null;
    }

    const value = control.value.toString().trim();

    const htmlPattern =
      /(<[^>]+>|&lt;|&gt;|javascript:|onerror=|onload=|<script|<\/script>)/gi;

    if (htmlPattern.test(value)) {
      return { invalidHtml: true };
    }

    return null;
  }

  getCharacterCount(controlName: string): number {
    return (this.icdForm.get(controlName)?.value || '').length;
  }

  getMaxLength(controlName: string): number {
    return this.fieldMaxLengths[controlName] || 0;
  }

  reset() {
    this.formResetToggle = false;

    setTimeout(() => {
      this.formResetToggle = true;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.selectEl?.nativeElement) {
      try {
       // $(this.selectEl.nativeElement).select2('destroy');
      } catch (e) {
      }
    }

    this.modalClosedCallback = null;
  }

  private buildFormSnapshot(): Record<string, string> {
    const raw = this.icdForm.getRawValue();
    const snap: Record<string, string> = {};
    Object.keys(raw).forEach(k => {
      const ctrl = this.icdForm.get(k);
      if (ctrl && ctrl.disabled) { return; } // skip disabled/read-only fields — user cannot act on the advisory
      const v = raw[k];
      if (v !== null && v !== undefined && typeof v !== 'object') {
        snap[k] = String(v);
      }
    });
    return snap;
  }

  runPreSubmitReview(): void {
    this.preSubmitLoading = true;
    this.preSubmitIssues = [];

    const invalidNameChars = /[0-9@#$%^&*()+={\[\]}|\\<>]/;
    [{ field: 'Owner_First_Name', label: 'Owner First Name' },
     { field: 'Owner_Middle_Name', label: 'Owner Middle Name' },
     { field: 'Owner_Last_Name', label: 'Owner Last Name' }].forEach(n => {
      const val = (this.icdForm.get(n.field)?.value ?? '') as string;
      if (val && invalidNameChars.test(val)) {
        this.preSubmitIssues.push({
          fieldName: n.field, label: n.label,
          issue: 'Name contains invalid characters (digits or symbols)',
          severity: 'error', suggestedFix: null, canAutoFix: false
        });
      }
    });

    Object.keys(this.icdForm.controls).forEach(fieldName => {
      const ctrl = this.icdForm.get(fieldName);
      if (!ctrl || !ctrl.invalid || !ctrl.errors) return;
      const firstErrorKey = Object.keys(ctrl.errors)[0];
      const errVal = ctrl.errors[firstErrorKey];
      if (errVal === null || typeof errVal !== 'object' || !('message' in errVal)) return;
      this.preSubmitIssues.push({
        fieldName,
        label: errVal.label ?? fieldName,
        issue: errVal.message,
        severity: 'error',
        suggestedFix: errVal.suggestedFix ?? null,
        canAutoFix: errVal.canAutoFix ?? false,
      });
    });

    this.preSubmitIssues = [...this.preSubmitIssues, ...this.buildVerificationIssues()];

    this.agentService.getPreSubmitReview(this.buildFormSnapshot()).subscribe({
      next: (res: any) => {
        this.preSubmitIssues = [...this.preSubmitIssues, ...(res.issues ?? [])];
        this.preSubmitLoading = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.preSubmitIssues.forEach(issue => {
          if (issue.severity === 'error') {
            const ctrl = this.icdForm.get(issue.fieldName);
            if (ctrl) { ctrl.setErrors({ aiReview: issue.issue }); ctrl.markAsTouched(); }
          }
        });
      },
      error: () => {
        this.preSubmitIssues = [];
        this.preSubmitLoading = false;
      }
    });
  }

  private buildVerificationIssues(): PreSubmitIssue[] {
    const docLabels: { [key: string]: string } = {
      Attach_Govt_Issued_ID: 'Government Issued ID',
    };
    const issues: PreSubmitIssue[] = [];
    Object.entries(this.verificationState).forEach(([controlName, state]) => {
      if (state !== 'fail' && state !== 'warn') return;
      const label = docLabels[controlName] ?? controlName;
      const fieldIssues = this.verificationIssues[controlName] ?? [];
      if (fieldIssues.length > 0) {
        fieldIssues.forEach(issue => issues.push({
          fieldName: controlName, label,
          issue, severity: 'warning', suggestedFix: null, canAutoFix: false
        }));
      } else {
        issues.push({
          fieldName: controlName, label,
          issue: state === 'fail' ? 'Document verification failed' : 'Document accepted with notes',
          severity: 'warning', suggestedFix: null, canAutoFix: false
        });
      }
    });
    return issues;
  }

  get preSubmitWarnings(): PreSubmitIssue[] {
    return this.preSubmitIssues.filter(i => i.severity === 'warning');
  }

  get hasDocVerificationBlock(): boolean {
    return Object.values(this.verificationState).some(s => s === 'verifying' || s === 'fail');
  }

  onPreSubmitDismiss(): void {
    this.preSubmitIssues.forEach(issue => {
      if (issue.severity === 'error') {
        const ctrl = this.icdForm.get(issue.fieldName);
        if (ctrl) { ctrl.setErrors(null); ctrl.updateValueAndValidity(); }
      }
    });
    this.showPreSubmitReview = false;
  }

  onPreSubmitDoSubmit(): void {
    this.preSubmitIssues.forEach(issue => {
      if (issue.severity === 'error') {
        const ctrl = this.icdForm.get(issue.fieldName);
        if (ctrl) { ctrl.setErrors(null); ctrl.updateValueAndValidity(); }
      }
    });
    this.showPreSubmitReview = false;
    this.saveData();
  }

  onPreSubmitRecheck(): void {
    this.runPreSubmitReview();
  }

  onPreSubmitAutoFix(issue: PreSubmitIssue): void {
    const ctrl = this.icdForm.get(issue.fieldName);
    if (issue.suggestedFix != null && ctrl) {
      ctrl.setValue(issue.suggestedFix, { emitEvent: true });
      ctrl.markAsDirty();
      ctrl.markAsTouched();
    }
    this.runPreSubmitReview();
  }

  onPreSubmitNavigate(fieldName: string): void {
    this.showPreSubmitReview = false;
    setTimeout(() => {
      const el =
        document.querySelector<HTMLElement>(`[formControlName="${fieldName}"]`) ??
        document.querySelector<HTMLElement>(`#${fieldName}`);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        el.focus?.();
      }
    }, 180);
  }

  private triggerDocumentVerification(controlName: string): void {
    const docType = this.VERIFIED_DOC_TYPES[controlName];
    if (!docType) return;

    const fileEntry = this.fileData.find(f => f.attachment_Type === controlName);
    if (!fileEntry) return;

    this.verificationState[controlName] = 'verifying';
    this.verificationIssues[controlName] = [];

    const ext = fileEntry.attachment_FileName.split('.').pop()?.toLowerCase() ?? '';
    const mimeMap: Record<string, string> = {
      pdf: 'application/pdf', jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png', xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', xls: 'application/vnd.ms-excel', csv: 'text/csv'
    };
    const mimeType = mimeMap[ext] ?? 'application/octet-stream';

    const formValues = this.icdForm.getRawValue();
    const body = {
      documentType: docType,
      base64Content: fileEntry.attachment_Base64,
      mimeType,
      companyName: (() => {
        if (docType === 'GovernmentID') {
          const first = formValues.Owner_Preferred_First_Name || formValues.Owner_First_Name || '';
          const last = formValues.Owner_Preferred_Last_Name || formValues.Owner_Last_Name || '';
          return (first + ' ' + last).trim();
        }
        return formValues.Full_Legal_Company_Name || '';
      })(),
      taxId: formValues.Tax_ID || '',
      stateOfIncorporation: formValues.State_of_Incorporation || '',
      provinceOfIncorporation: formValues.Provinence_of_Incorporation || '',
      dateOfIncorporation: '',
    };

    this.sfDataService.verifyDocument(body).subscribe({
      next: (result: any) => {
        if (result.overallPass) {
          this.verificationState[controlName] = result.issues && result.issues.length > 0 ? 'warn' : 'pass';
        } else {
          this.verificationState[controlName] = 'warn';
        }
        this.verificationIssues[controlName] = result.issues || [];
      },
      error: () => {
        this.verificationState[controlName] = 'warn';
        this.verificationIssues[controlName] = ['Document verification unavailable — please verify manually.'];
      }
    });
  }

}
